import { 
  MultiSelect,
  IDataItem, 
  TSelectContainerTriggerAreaStatus, 
  ISelectContainerTriggerAreaAltText 
} from "@ceridianhcm/components"
import React, { useEffect, useRef, useState } from "react";

const textMap = {
  clearButton: "Clear All",
  clearButtonAriaLabel: "Clear all selections",
  removeTagButtonAriaLabel: "Remove {0}",
  selectedItem: "{0} selected",
  unselectedItem: "{0} not selected",
  moreSelectedOptionsLabel: "+{0} more",
  spinnerAriaLabel: "Loading",
};

export const FilteredMultiSelect: React.FC<{
  id: string,
  selectedOptions: IDataItem[];
  options: IDataItem[],
  onChange: (dataItems?: IDataItem[], index?: number) => void,
  onClear: () => void,
  ariaInputLabel: string,
  testId?: string,
  ariaLabel?: string,
  disabled?: boolean,
  required?: boolean,
  label?: string,
  status?: TSelectContainerTriggerAreaStatus,
  helpText?: string,
  helpTextPrefix?: string,
  itemRenderer?: (dataItem: IDataItem, selected: boolean) => React.ReactNode,
  maxItems?: number,
  altTextMap?: ISelectContainerTriggerAreaAltText,
  overrideNoResultRender?: (id: string) => React.ReactNode,
  onFocus?: (e: React.FocusEvent) => void,
  noResultsText: string,
  comboBoxId: number
}> = ({
  id,
  options,
  selectedOptions,
  onChange,
  onClear,
  ariaInputLabel,
  testId,
  ariaLabel,
  disabled,
  required,
  label,
  status,
  helpText,
  helpTextPrefix,
  itemRenderer,
  maxItems,
  altTextMap,
  overrideNoResultRender,
  onFocus,
  noResultsText,
  comboBoxId
}) => 
{
  const [inputValue, setInputValue] = useState('');
  const [filteredOptions, setFilterOptions] = useState<IDataItem[]>(options);
  const ariaListBoxResults = useRef(options.length.toString() + 'results found.');
  const handleInputValueChange = (value:string) => {
    setInputValue(value);
  };
  const handleBlur = () => {
    setInputValue('');
  };

  useEffect(() => {
    if(comboBoxId===1)
    {
      setFilterOptions(
        options.filter((option) =>
          option.title.split(' ').slice(1).join(' ').toLowerCase().includes(inputValue.toLowerCase())
        ));
    }
    else{
      setFilterOptions(
        options.filter((option) =>
          option.title.toLowerCase().includes(inputValue.toLowerCase())
        ));
    }
  }, [inputValue, options, comboBoxId]);

    return (<MultiSelect
            inputValue={inputValue}
            options={filteredOptions}
            onInputValueChange={handleInputValueChange}
            id={id}
            selectedOptions={selectedOptions}
            onChange={onChange}
            onClear={onClear}
            ariaInputLabel={ariaInputLabel}
            testId={testId}
            disabled={disabled}
            required={required}
            label={label}
            status={status}
            helpText={helpText}
            helpTextPrefix={helpTextPrefix}
            itemRenderer={itemRenderer}
            maxItems={maxItems}
            onBlur={handleBlur}
            noResultsText={noResultsText}
            ariaListboxResult={ariaListBoxResults.current}
            textMap={textMap}
        />);
};